"use client";

import { type ReactNode } from "react";

type Props = {
  locale: string;
  children: ReactNode;
};

export function Providers({ locale: _locale, children }: Props) {
  return <>{children}</>;
}
